/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
// import '@here/hds-components/icon'
import { Input } from '@here/hds-input'
import { html } from 'lit'
import { customElement } from 'lit/decorators.js'
import { classMap } from 'lit/directives/class-map.js'

import { style } from './style'

@customElement('wego-input')
export class WegoInput extends Input {
  static get styles(): any {
    return [super.styles, style]
  }

  protected render() {
    const classes = {
      disabled: this.disabled,
      error: this.error,
      readonly: this.readonly,
      required: this.required,
      [`-${this.size}`]: true,
    }

    return html`
      <div class="wrapper">
        ${super.renderLabel()}
        <div class="input-wrapper ${classMap(classes)}">
          ${super.renderIcon()} ${super.renderInput()}
          <slot class="action-slot" name="action"></slot>
          ${super.renderHelperText()}
        </div>
      </div>
    `
  }
}
